import { Badge } from "@/components/ui/badge";
import {
  type CreditAction, type CreditAuditRow, type Identity,
  fmtDate, fmtNum, labelFor,
} from "./types";

const actionBadge = (a: CreditAction) => {
  if (a === "credit_grant") return <Badge variant="default">grant</Badge>;
  if (a === "credit_grant_reversal") return <Badge variant="destructive">reversal</Badge>;
  return <Badge variant="secondary">bulk</Badge>;
};

export const CreditAuditTable = ({
  rows, identities,
}: {
  rows: CreditAuditRow[];
  identities: Record<string, Identity>;
}) => (
  <div className="overflow-x-auto rounded-md border border-border">
    <table className="w-full text-sm">
      <thead className="bg-muted/50 text-xs uppercase text-muted-foreground">
        <tr>
          <th className="px-3 py-2 text-left">When</th>
          <th className="px-3 py-2 text-left">Action</th>
          <th className="px-3 py-2 text-left">Admin</th>
          <th className="px-3 py-2 text-left">Target</th>
          <th className="px-3 py-2 text-right">Amount</th>
          <th className="px-3 py-2 text-left">Category</th>
          <th className="px-3 py-2 text-left">Reason</th>
          <th className="px-3 py-2 text-left">Batch</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((r) => {
          const m = (r.metadata ?? {}) as Record<string, unknown>;
          const amount = (m.amount as number | undefined) ?? null;
          const isReversal = r.action === "credit_grant_reversal";
          return (
            <tr key={r.id} className="border-t border-border/60">
              <td className="whitespace-nowrap px-3 py-2 text-xs text-muted-foreground">
                {fmtDate(r.created_at)}
              </td>
              <td className="px-3 py-2">{actionBadge(r.action)}</td>
              <td className="px-3 py-2 text-xs">{labelFor(r.admin_user_id, identities)}</td>
              <td className="px-3 py-2 text-xs">
                {r.action === "credit_grant_bulk"
                  ? `${(m.user_count as number) ?? 0} users`
                  : labelFor(r.target_user_id, identities)}
              </td>
              <td
                className={`px-3 py-2 text-right font-mono text-xs ${
                  isReversal ? "text-destructive" : "text-foreground"
                }`}
              >
                {amount != null ? `${isReversal ? "-" : "+"}${fmtNum(amount)}` : "—"}
              </td>
              <td className="px-3 py-2 text-xs">{(m.category as string) ?? "—"}</td>
              <td
                className="max-w-xs truncate px-3 py-2 text-xs text-muted-foreground"
                title={(m.reason as string) ?? ""}
              >
                {(m.reason as string) ?? ""}
              </td>
              <td className="px-3 py-2 font-mono text-[10px] text-muted-foreground">
                {(m.batch_id as string)?.slice(0, 8) ?? ""}
                {m.batch_id ? "…" : ""}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  </div>
);
